
const digest = '4399a54966191448d8ec4d651d57d0d0be3382ee8fda7cdf0c4bf57933a9acb6';
const classes = {"wrapper":"_wrapper_kwp7r_1","controls":"_controls_kwp7r_4"};
const css = `._wrapper_kwp7r_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_kwp7r_1 ._controls_kwp7r_4 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  gap: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  